export default __webpack_public_path__ + "static/favicon-e863871d45d17b4210114356d2c089d6.png";